/* eslint-disable react/destructuring-assignment, babel/new-cap */
// Copyright (c) 2018 Deere & Company

import React, {
    Component,
} from 'react';
import Card from './card';
import { DropTarget } from 'react-dnd';
import PropTypes from 'prop-types';

export const cardTarget = {
    drop(props, monitor, component) {

        const { id } = props;
        const sourceObj = monitor.getItem();
        component.props.onCardPush(sourceObj.card, sourceObj.listId);

        return {
            listId: id,
        };

    },
};

class Container extends Component {

    render() {

        const {
            canDrop,
            connectDropTarget,
            isOver,
        } = this.props;

        const isActive = canDrop && isOver;

        const className = isActive ? 'container-active' : 'container-inactive';

        return connectDropTarget(
            <div className={`container ${className}`}>
                {this.props.list.map((card, index) => (
                    <Card
                        card={card}
                        index={index}
                        key={card[this.props.idAttribute]}
                        listId={this.props.id}
                        moveCard={this.props.onCardMove}
                        removeCard={this.props.onCardRemove}
                        {...this.props}
                    />
                ))}
            </div>,
        );

    }

}

Container.displayName = 'Container';
Container.propTypes = {
    canDrop: PropTypes.bool,
    connectDropTarget: PropTypes.func,
    id: PropTypes.string.isRequired,
    idAttribute: PropTypes.string.isRequired,
    isDisplayValueMapped: PropTypes.bool.isRequired,
    isOver: PropTypes.bool,
    list: PropTypes.array.isRequired,
    mappingId: PropTypes.string,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    onCardMove: PropTypes.func.isRequired,
    onCardPush: PropTypes.func.isRequired,
    onCardRemove: PropTypes.func.isRequired,
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(Container);

/* eslint-enable babel/new-cap */
